import React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { RequestDetailIndexDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const RequestDetailIndex = () => {
  const { id } = useParams()
  const { loading: loadingResources, data } = useQuery(RequestDetailIndexDocument, {
    variables: { ids: [String(id)] },
    fetchPolicy: 'network-only',
  })

  const trainingRequest = data?.trainings.trainingRequestsConnection?.nodes.find(
    (tr) => tr.id == String(id)
  )

  if (loadingResources) return <></>

  return (
    <ResponsivePage.Body authorized={!!trainingRequest?._policies?.read.can}>
      <Outlet context={{ trainingRequest, loadingResources }} />
    </ResponsivePage.Body>
  )
}

export default RequestDetailIndex
